<ng-container *transloco="let t">
  @if (sections().length > 0) {
    <div class="promotion-tags">
      @for (section of sections(); track $index) {
        @switch (section.mode) {
          @case ('literal') {
            <pxw-tag type="success" size="xs">
              {{ t(section.key, section.params) }}
            </pxw-tag>
          }
          @case ('grouped') {
            <div ngbDropdown [autoClose]="true" placement="bottom-start">
              <pxw-tag class="grouped-tag" type="success" size="xs" ngbDropdownToggle>
                {{ t(section.headerKey, section.headerParams) }}
                &nbsp;
                <pxw-icon icon="info" />
              </pxw-tag>
              <div ngbDropdownMenu class="grouped-breakdown">
                @for (line of section.breakdownLines; track $index) {
                  <div class="breakdown-line">
                    <span>{{ t(line.labelKey, line.labelParams) }}</span>
                    <span class="tier-percentage">
                      {{ t('promotionTag.percentageOff', { percentage: line.percentage }) }}
                    </span>
                  </div>
                }
                @if (section.disclaimerKey) {
                  <div class="breakdown-disclaimer">* {{ t(section.disclaimerKey) }}</div>
                }
              </div>
            </div>
          }
        }
      }
    </div>
    <p class="applied-in-cart-note">* {{ t('promotionTag.appliedInCartNote') }}</p>
  }
</ng-container>
